import PropTypes from 'prop-types';
import styled from 'styled-components';
import { INPUT_SIZES } from '../../constants';
import { SelectMixin } from '../../mixins/components/SelectMixin';
import { FormControl } from '../FormControl/FormControl';

/**
 * A basic [HTML select element](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/select)
 * where you provide your on `option` children. You can also generate options from a data set using
 * the `DataSelect` component.
 *
 * @related ['DataSelect', 'FormField', 'ReadOnlySelect']
 * @since 2.1.0
 */
var Select = /*#__PURE__*/styled(FormControl).withConfig({
  displayName: "Select",
  componentId: "c11n-8-107-0__sc-1p9r1r3-0"
})(["", ""], SelectMixin);
Select.displayName = 'Select';
Select.propTypes = {
  /**
   * `<option>` and `<optgroup>` nodes
   */
  children: PropTypes.node.isRequired,
  /**
   * Displays the select in a disabled state. Can also be inherited from a FormField parent.
   */
  disabled: PropTypes.bool,
  /**
   * Displays the select in an error state. Can also be inherited from a FormField parent.
   */
  error: PropTypes.bool,
  /**
   * Selects are fluid by default which means they stretch to fill the entire width of their
   * container. When `fluid="false"`, the select's width is set to `auto`.
   */
  fluid: PropTypes.bool,
  /**
   * Determines the size of the select.
   */
  size: PropTypes.oneOf(Object.values(INPUT_SIZES)),
  /**
   * Indicates the select is required. Can also be inherited from a FormField parent.
   */
  required: PropTypes.bool,
  /**
   * styled-components forwarded `as` component.
   * @ignore
   */
  forwardedAs: PropTypes.string
};
Select.defaultProps = {
  fluid: true,
  size: INPUT_SIZES.md,
  forwardedAs: 'select'
};

/** @component */
export { Select };